import React from 'react';

// Exportar a função handleDownload
export const handleDownload = () => {
  // Caminho do arquivo na pasta public
  const filePath = `${process.env.PUBLIC_URL}/CADASTRAMENTO_DE_E-MAIL_PREFEITURAS.doc`;
  
  // Criar um elemento de link e disparar o download
  const link = document.createElement('a');
  link.href = filePath;
  link.download = 'CADASTRAMENTO_DE_E-MAIL_PREFEITURAS.doc'; // Nome do arquivo baixado
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const DownloadFormularioWord = () => {
  return (
    <div>
      <button onClick={handleDownload}>Baixar Arquivo .doc</button>
    </div>
  );
};

export default DownloadFormularioWord;
